import { useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { getRecommendations } from '../../services/recommendation';
import useAppMeta from './useAppMeta';

const useRecommendationDetails = ({
  enabled,
  basketType,
}: {
  enabled: boolean;
  basketType?: string;
}) => {
  const [{ data: meta }] = useAppMeta();
  const type = basketType || meta?.transactionType;
  const queryKey = useMemo(() => [`recommendation-${type}`], [type]);
  const pathName = usePathname();
  const fetchRecommendations = async () => {
    if (!type) {
      return;
    }
    return getRecommendations({
      basketType: type,
      live: true,
    });
  };

  return useQuery({
    queryKey,
    queryFn: fetchRecommendations,
    enabled: !!type && enabled,
    gcTime: 0,
  });
};

export default useRecommendationDetails;
